import React, { useState, useEffect, useContext } from 'react';
import { useParams, useHistory } from 'react-router-dom';
import { Toolbar, Paper, Button, Grid, Typography } from '@material-ui/core';
import SaveIcon from '@material-ui/icons/Save';
import DeleteIcon from '@material-ui/icons/Delete';
import InfoOutlinedIcon from '@material-ui/icons/InfoOutlined';
import AssignmentIndOutlinedIcon from '@material-ui/icons/AssignmentIndOutlined';
import WarningAmberIcon from '@material-ui/icons/Warning';
import { Formik } from 'formik';
import { makeStyles } from '@material-ui/core/styles';

import SideMenu from '../../components/SideMenu';
import Alert from '../../components/Alert';
import Input from '../../components/Input';
import Popup from '../../components/Popup';
import { ListPageHeading } from '../../components/ListPageLayout';

import api from '../../services/api';
import { PermissionsContext } from '../../providers/Permissions';

export default function PersonTypeModify() {
    const classes = useStyles();

    const {
        PermissionWrapper,
    } = useContext(PermissionsContext);

    const [message, setMessage] = useState({
        open: false,
        variant: '',
        text: '',
    });

    const { id } = useParams();
    const history = useHistory();

    const [refresh, setRefresh] = useState(true)
    const [personTypeValue, setPersonTypeValue] = useState({
        name: '',
    });
    useEffect(() => {
        const loadPersonType = async () => {
            try {
                const result = await api.get(`/person_type/detail/${id}`);

                const { personType } = result.data;

                setPersonTypeValue(personType);
            } catch (err) {
                setMessage({
                    open: true,
                    variant: "error",
                    text: err.error,
                });
            }
        };
        loadPersonType();
    }, [id, history, refresh]);

    const savePersonType = async (values, formik) => {
        try {

            const personTypeData = {
                ...values,
            };
            const result = await api.post(`/person_type/modify/${id}`, personTypeData);
            const { personType } = result.data;

            formik.setSubmitting(false);

            setRefresh(!refresh)
            setMessage({
                open: true,
                variant: 'success',
                text: `Tipo de pessoa "${personType.name}" modificado com sucesso!`,
            });
        }
        catch (err) {
            setMessage({
                open: true,
                variant: 'error',
                text: err.error,
            });
        }
    };

    const [openDeletePopup, setOpenDeletePopup] = useState(false);
    const [isDeleting, setIsDeleting] = useState(false);
    const deletePersonType = async () => {
        try {
            setIsDeleting(true);

            const result = await api.delete(`/person_type/delete/${id}`);

            const { deletedPersonType } = result.data;

            setIsDeleting(false);

            if (deletedPersonType) {
                setOpenDeletePopup(false);
                setMessage({
                    open: true,
                    variant: 'success',
                    text: `Tipo de pessoa "${deletedPersonType.name}"" deletado com sucesso!`,
                });
                history.goBack()
            }
        } catch (err) {
            setIsDeleting(false);
            setMessage({
                open: true,
                variant: 'error',
                text: err.error,
            });
        }
    }

    const closeMessage = () => {
        setMessage({
            open: false,
            variant: '',
            text: '',
        });
    };

    return (
        <div className={classes.root}>
            <SideMenu />
            <main className={classes.content}>
                <Toolbar />
                <Grid container spacing={3} className={classes.pageGrid}>
                    <Grid item xs={12}>
                        <ListPageHeading icon="person" title="Editar tipo de pessoa" />
                    </Grid>
                    <Formik
                        initialValues={personTypeValue}
                        enableReinitialize={true}
                        onSubmit={savePersonType}
                    >
                        {({ values, handleChange, handleSubmit, isSubmitting }) => (
                            <Grid item xs={12}>
                                <Paper elevation={0} className={classes.formCard}>
                                    <div className={classes.cardHeader}>
                                        <div className={classes.cardHeaderIcon}>
                                            <AssignmentIndOutlinedIcon />
                                        </div>
                                        <div>
                                            <Typography className={classes.cardTitle}>
                                                Informações do tipo
                                            </Typography>
                                            <Typography className={classes.cardSubtitle}>
                                                Atualize como este grupo de pessoas será identificado no sistema.
                                            </Typography>
                                        </div>
                                    </div>

                                    <form id="person-type-modify" onSubmit={handleSubmit} className={classes.form}>
                                        <div className={classes.formBody}>
                                            <div className={classes.infoBanner}>
                                                <InfoOutlinedIcon />
                                                <Typography>
                                                    Alterações no nome serão refletidas nas telas de pessoas, filtros e relatórios.
                                                </Typography>
                                            </div>

                                            <div className={classes.fieldSection}>
                                                <Typography className={classes.fieldSectionTitle}>
                                                    Identificação
                                                </Typography>
                                                <Typography className={classes.fieldSectionDescription}>
                                                    Informe um nome claro e objetivo para o tipo de pessoa.
                                                </Typography>
                                                <div className={classes.nameField}>
                                                    <Input
                                                        label="Nome"
                                                        textFieldProps={{
                                                            name: 'name',
                                                            id: 'person-type-name',
                                                            placeholder: 'Nome do tipo de pessoa',
                                                            onChange: handleChange,
                                                            value: values.name,
                                                            fullWidth: true,
                                                            required: true,
                                                        }}
                                                    />
                                                    <Typography className={classes.fieldHint}>
                                                        Campo obrigatório
                                                    </Typography>
                                                </div>
                                            </div>
                                        </div>

                                        <div className={classes.formActions}>
                                            <PermissionWrapper route="/tipo_de_pessoa/deletar/:id">
                                                <Button
                                                    type="button"
                                                    variant="outlined"
                                                    endIcon={<DeleteIcon />}
                                                    onClick={() => setOpenDeletePopup(true)}
                                                    id="delete"
                                                    className={classes.deleteButton}
                                                >
                                                    Excluir tipo
                                                </Button>
                                            </PermissionWrapper>
                                            <Button
                                                disabled={isSubmitting}
                                                type="submit"
                                                variant="contained"
                                                form="person-type-modify"
                                                color="primary"
                                                endIcon={<SaveIcon />}
                                                id="salvar"
                                                className={classes.saveButton}
                                            >
                                                {isSubmitting ? 'Salvando...' : 'Salvar alterações'}
                                            </Button>
                                        </div>
                                    </form>
                                </Paper>
                            </Grid>
                        )}
                    </Formik>
                </Grid>
                <Popup
                    title="Excluir tipo de pessoa"
                    openPopup={openDeletePopup}
                    setOpenPopup={setOpenDeletePopup}
                    width="92%"
                    maxWidth="sm"
                >
                    <div className={classes.deleteModal}>
                        <div className={classes.deleteWarning}>
                            <div className={classes.deleteWarningIcon}>
                                <WarningAmberIcon />
                            </div>
                            <div>
                                <Typography className={classes.deleteModalTitle}>
                                    Confirmar exclusão
                                </Typography>
                                <Typography className={classes.deleteModalText}>
                                    Deseja realmente excluir o tipo de pessoa “{personTypeValue.name}”?
                                </Typography>
                            </div>
                        </div>
                        <Typography className={classes.deleteNotice}>
                            Esta ação não poderá ser desfeita.
                        </Typography>
                        <div className={classes.deleteModalActions}>
                            <Button
                                variant="outlined"
                                onClick={() => setOpenDeletePopup(false)}
                                className={classes.cancelButton}
                            >
                                Cancelar
                            </Button>
                            <Button
                                disabled={isDeleting}
                                variant="contained"
                                onClick={() => deletePersonType()}
                                color="secondary"
                                endIcon={<DeleteIcon />}
                                className={classes.confirmDeleteButton}
                            >
                                {isDeleting ? 'Excluindo...' : 'Excluir tipo'}
                            </Button>
                        </div>
                    </div>
                </Popup>
                {!!message.open && (
                    <Alert
                        open={message.open}
                        autoHideDuration={6000}
                        anchorOrigin={{ vertical: 'bottom', horizontal: 'left' }}
                        severity={message.variant}
                        onClose={closeMessage}
                    >
                        {message.text}
                    </Alert>
                )}
            </main>
        </div>
    );
}

const useStyles = makeStyles((theme) => ({
    root: {
        display: 'flex',
        minHeight: '100vh',
    },
    content: {
        flexGrow: 1,
        minWidth: 0,
        padding: theme.spacing(3),
        marginBottom: theme.spacing(6),
        marginTop: theme.spacing(5),
        [theme.breakpoints.down('xs')]: {
            padding: theme.spacing(2),
        },
    },
    pageGrid: {
        marginLeft: 'auto',
        marginRight: 'auto',
        maxWidth: 960,
    },
    formCard: {
        backgroundColor: '#fff',
        border: '1px solid #e5e7eb',
        borderRadius: 16,
        boxShadow: '0 10px 30px rgba(15, 23, 42, .05)',
        overflow: 'hidden',
    },
    cardHeader: {
        alignItems: 'center',
        borderBottom: '1px solid #e5e7eb',
        display: 'flex',
        gap: theme.spacing(1.5),
        padding: theme.spacing(2.5, 3),
        [theme.breakpoints.down('xs')]: {
            alignItems: 'flex-start',
            padding: theme.spacing(2),
        },
    },
    cardHeaderIcon: {
        alignItems: 'center',
        backgroundColor: '#e3f2fd',
        borderRadius: 10,
        color: '#1976d2',
        display: 'flex',
        flexShrink: 0,
        height: 40,
        justifyContent: 'center',
        width: 40,
        '& svg': {
            fontSize: 21,
        },
    },
    cardTitle: {
        color: '#1e293b',
        fontSize: '1rem',
        fontWeight: 700,
    },
    cardSubtitle: {
        color: '#64748b',
        fontSize: '.82rem',
        lineHeight: 1.45,
        marginTop: 2,
    },
    form: {
        display: 'flex',
        flexDirection: 'column',
    },
    formBody: {
        padding: theme.spacing(3),
        [theme.breakpoints.down('xs')]: {
            padding: theme.spacing(2),
        },
    },
    infoBanner: {
        alignItems: 'flex-start',
        background: 'linear-gradient(135deg, #eff6ff 0%, #f8fafc 100%)',
        border: '1px solid #dbeafe',
        borderRadius: 12,
        color: '#64748b',
        display: 'flex',
        gap: theme.spacing(1),
        marginBottom: theme.spacing(2.5),
        padding: theme.spacing(1.5),
        '& svg': {
            color: '#1976d2',
            flexShrink: 0,
            fontSize: 20,
            marginTop: 1,
        },
        '& p': {
            fontSize: '.82rem',
            lineHeight: 1.5,
        },
    },
    fieldSection: {
        backgroundColor: '#fbfdff',
        border: '1px solid #e2e8f0',
        borderRadius: 14,
        padding: theme.spacing(2),
    },
    fieldSectionTitle: {
        color: '#1e293b',
        fontSize: '.95rem',
        fontWeight: 700,
    },
    fieldSectionDescription: {
        color: '#64748b',
        fontSize: '.78rem',
        lineHeight: 1.4,
        marginTop: 1,
    },
    nameField: {
        marginTop: theme.spacing(2),
        maxWidth: 600,
        '& .MuiTextField-root': {
            width: '100%',
        },
    },
    fieldHint: {
        color: '#94a3b8',
        fontSize: '.7rem',
        marginLeft: theme.spacing(.25),
        marginTop: theme.spacing(.5),
    },
    formActions: {
        alignItems: 'center',
        borderTop: '1px solid #e5e7eb',
        display: 'flex',
        gap: theme.spacing(1.5),
        justifyContent: 'flex-end',
        padding: theme.spacing(2, 3),
        [theme.breakpoints.down('xs')]: {
            alignItems: 'stretch',
            flexDirection: 'column-reverse',
            padding: theme.spacing(1.5, 2),
        },
    },
    deleteButton: {
        borderColor: '#fecaca',
        borderRadius: 9,
        color: '#b91c1c',
        fontWeight: 600,
        marginRight: 'auto',
        minHeight: 42,
        textTransform: 'none',
        '&:hover': {
            backgroundColor: '#fef2f2',
            borderColor: '#f87171',
        },
        [theme.breakpoints.down('xs')]: {
            marginRight: 0,
            width: '100%',
        },
    },
    saveButton: {
        borderRadius: 9,
        boxShadow: '0 6px 14px rgba(25, 118, 210, .2)',
        fontWeight: 700,
        minHeight: 42,
        minWidth: 190,
        textTransform: 'none',
        [theme.breakpoints.down('xs')]: {
            width: '100%',
        },
    },
    deleteModal: {
        paddingTop: theme.spacing(.5),
    },
    deleteWarning: {
        alignItems: 'center',
        backgroundColor: '#fef2f2',
        border: '1px solid #fecaca',
        borderRadius: 14,
        display: 'flex',
        gap: theme.spacing(1.5),
        padding: theme.spacing(2),
    },
    deleteWarningIcon: {
        alignItems: 'center',
        backgroundColor: '#fee2e2',
        borderRadius: 11,
        color: '#b91c1c',
        display: 'flex',
        flexShrink: 0,
        height: 42,
        justifyContent: 'center',
        width: 42,
    },
    deleteModalTitle: {
        color: '#7f1d1d',
        fontSize: '.95rem',
        fontWeight: 700,
    },
    deleteModalText: {
        color: '#991b1b',
        fontSize: '.82rem',
        lineHeight: 1.45,
        marginTop: 2,
    },
    deleteNotice: {
        color: '#64748b',
        fontSize: '.78rem',
        marginTop: theme.spacing(1.5),
    },
    deleteModalActions: {
        borderTop: '1px solid #e5e7eb',
        display: 'flex',
        gap: theme.spacing(1),
        justifyContent: 'flex-end',
        margin: theme.spacing(2, -3, -2.5),
        padding: theme.spacing(2, 3),
        [theme.breakpoints.down('xs')]: {
            flexDirection: 'column-reverse',
            margin: theme.spacing(2, -2, -2.5),
            padding: theme.spacing(1.5, 2),
        },
    },
    cancelButton: {
        borderColor: '#cbd5e1',
        borderRadius: 9,
        color: '#475569',
        fontWeight: 600,
        minWidth: 120,
        textTransform: 'none',
    },
    confirmDeleteButton: {
        borderRadius: 9,
        fontWeight: 700,
        minWidth: 150,
        textTransform: 'none',
    },
}));
